var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-list"},[_c('button',{on:{"click":_vm.clickEvent}},[_vm._v(_vm._s(_vm.text))]),(+_vm.nums > 1)?_c('button',{on:{"click":_vm.close}},[_vm._v("关闭")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }